import React from 'react';
import moment from 'moment'
import { makeStyles, withStyles  } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { getTransactionHistory } from '../../redux/actions/ContractPOAction'
import Link from '@material-ui/icons/Link';
import AdjustmentService from '../../services/AdjustmentService'

const useStyles = makeStyles({
    bold: {
      fontWeight: 'bold',
      color:'#4D4D4D'
    },
    padding20:{
        paddingLeft:20
    },
    name:{
        fontWeight: 'bold',
        color:'#4D4D4D',
        fontSize:'0.9em',
    },
    value:{
        color:'#4D4D4D',
        fontSize:'0.9em'
    },
    header:{
        backgroundColor:'#0072BC',
        paddingTop:6,
        paddingBottom:6,
        color:'#ffffff'
    },
    table:{
    },
    even:{
        fontSize:'0.8em',
        backgroundColor:'#F2F2F2',
        border:'none'
    },
    odd:{
        fontSize:'0.8em',
        border:'none'
    },
    tableheader:{
        backgroundColor:'#B6D0FB',
        color:'#4D4D4D',
        border: '1px solid #B6D0FB'
    },
    tableheader_cell: {    
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft:10,
        paddingRight:10

    },
    table_cell: {    
        paddingTop: 7,
        paddingBottom: 7,
        paddingLeft:10,
        paddingRight:10
    },
    maingrid:{
        marginTop:20,
        marginBottom:20
    }
  });

  const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color:'#ffffff'
    },
  });

  const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} size="small" onClick={onClose}>
            <CloseIcon color="inherit" />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

const AdjustmentSelect = ({open,onClose,po_contract_no,data_type, onSelect})=>{

    const classess = useStyles();
    const [items,setItems] = React.useState([])
    const [isError,setIsError] = React.useState(false)
    const [isLoaded,setIsLoaded] = React.useState(false)
    const handleClose = () => {
        if(typeof onClose === 'function')
        {
            onClose();
        }
    };

    const handleGetTransactionHistory = async () =>{
        console.log('AdjustmentService.getSearchAdjustmentNo')
        AdjustmentService.getSearchAdjustmentNo(data_type,po_contract_no).then((response)=>{

            setItems(response.data)
            setIsLoaded(true)
        }).catch((error)=>{
            setIsError(true)
        })
    }

    React.useEffect(()=>{
        if(open)
        {
            setIsLoaded(false)
            setItems([]);
            setIsError(false)

            if(open && po_contract_no)
            {
                handleGetTransactionHistory();
            }
            
        }
    },[open,po_contract_no])

    const handleSelectItem = (item) =>{
        if(typeof onSelect === 'function')
        {
            onSelect(item)
        }
    }

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="transaction-history-dialog-title"
        aria-describedby="transaction-history-dialog-description"
        fullWidth 
        maxWidth={'sm'}
      >
        <DialogTitle onClose={handleClose} className={classess.header} id="transaction-history-dialog-title" >{"โปรดเลือกข้อมูลหนังสือแจ้งสิทธิ์การเรียกค่าปรับที่ได้จัดทำไว้ในระบบ"}</DialogTitle>
        <DialogContent>

          <TableContainer component={Paper}>
            <Table className={classess.table} size="small" aria-label="a dense table">
                <TableHead>
                <TableRow className={classess.tableheader}>
                    <TableCell className={classess.tableheader_cell} >No.</TableCell>
                    <TableCell className={classess.tableheader_cell} >เลขที่</TableCell>
                    <TableCell className={classess.tableheader_cell} >ลงวันที่</TableCell>
                    <TableCell className={classess.tableheader_cell} >Action</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {items.map((row,i) => (
                    <TableRow key={'transaction-history-row-'+i} className={ i % 2 == 0 ? classess.odd : classess.even}>
                      <TableCell className={classess.table_cell} align="center">{i+1}</TableCell>
                      <TableCell className={classess.table_cell} align="left">{row.adjust_no}</TableCell>
                      <TableCell className={classess.table_cell} align="left">{moment(row.adjust_date).format("DD/MM/YYYY")}</TableCell>
                      <TableCell className={classess.table_cell} align="left">
                      <Button  onClick={()=>{handleSelectItem(row)}}>Select</Button>
                      <Button target="_blank" href={"/#/AdjustmentDetail/"+row.adjustment_id}>View</Button>
                      </TableCell>
                    </TableRow>
                ))}

                  { isLoaded && isError === false && items.length === 0 &&<TableRow>
                    <TableCell colSpan={7} className={classess.table_cell} align="center">ไม่มีรายการ</TableCell>
                  </TableRow>}
                </TableBody>
            </Table>
            </TableContainer>

            { isError && isLoaded && <Typography variant="h6" align="center" color="error">ไม่มีรายการ</Typography> }

        </DialogContent>
      </Dialog>
    </div>
  );
}

export default AdjustmentSelect;